/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CellarTypeEnum = 1 | 2 | 3;

export const CellarTypeEnum = {
    NUMBER_1: 1 as CellarTypeEnum,
    NUMBER_2: 2 as CellarTypeEnum,
    NUMBER_3: 3 as CellarTypeEnum
};

